import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
/*
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';

import { tap, switchMap } from 'rxjs/operators';
*/
import { LocalStorage } from '@ngx-pwa/local-storage';

@Injectable({
    providedIn: 'root'
})
export class PayloadService {

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage
    ) { }


    getPayload() {
        return this.localStorage.getItem("payload");
    }
}
